/**
 * @desc 测试帐号
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(mailAccountCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/test/${mailAccountCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
